import { HStack, IconButton, Img, Link, Text, VStack } from '@chakra-ui/react';
import NextLink from 'next/link';
import { FaAddressCard, FaLinkedin } from 'react-icons/fa';
import React from 'react';
import { FaSquareXTwitter } from 'react-icons/fa6';
import type { Author } from '../../libs/sanity.queries';
import { urlForImage } from '../../libs/sanity.image';

export default function AuthorAvatar(props: Author & { showBio?: boolean }) {
  const { name, image, jobTitle, bio, homepage, twitter, linkedin, showBio, ...styleProps } = props;
  return (
    <VStack spacing={4} alignItems='start'>
      <HStack spacing={4} {...styleProps}>
        <Img
          src={urlForImage(image).height(96).width(96).fit('crop').url()}
          objectFit='cover'
          width='48px'
          height='48px'
          rounded='full'
          alt={name}
        />
        <VStack spacing={0} alignItems='start'>
          {linkedin && (
            <Text size='xl' fontWeight='bold' pt={2}>
              <Link as={NextLink} href={linkedin}>
                {name}
              </Link>
            </Text>
          )}
          {!linkedin && (
            <Text size='xl' fontWeight='bold'>
              {name}
            </Text>
          )}
          <HStack spacing={2}>
            <Text size='lg' color='bg-default-inverted'>
              {jobTitle}
            </Text>

            <HStack spacing={0}>
              {homepage && (
                <IconButton
                  as={NextLink}
                  variant='ghost'
                  color='brand.400'
                  href={homepage}
                  target='_blank'
                  rel='noopener'
                  aria-label='Homepage'
                  padding={0}
                  icon={<FaAddressCard fontSize='0.8rem' />}
                />
              )}
              {twitter && (
                <IconButton
                  as={NextLink}
                  variant='ghost'
                  color='brand.400'
                  href={twitter}
                  target='_blank'
                  rel='noopener'
                  aria-label='LinkedIn'
                  padding={0}
                  icon={<FaSquareXTwitter fontSize='0.8rem' />}
                />
              )}
              {linkedin && (
                <IconButton
                  as={NextLink}
                  variant='ghost'
                  color='brand.400'
                  href={linkedin}
                  target='_blank'
                  rel='noopener'
                  aria-label='LinkedIn'
                  padding={0}
                  icon={<FaLinkedin fontSize='0.8rem' />}
                />
              )}
            </HStack>
          </HStack>
        </VStack>
      </HStack>
      {showBio && bio && (
        <Text fontSize='sm' color='whiteAlpha.600'>
          {bio}
        </Text>
      )}
    </VStack>
  );
}
